import { render, staticRenderFns } from "./EmojicryptionSettings.vue?vue&type=template&id=53bd964d&scoped=true&"
import script from "./EmojicryptionSettings.vue?vue&type=script&lang=js&"
export * from "./EmojicryptionSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmojicryptionSettings.vue?vue&type=style&index=0&id=53bd964d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd964d",
  null
  
)

export default component.exports